// Source copy for the question-selection workflow. English-only initially:
// translated questions require a separate human-reviewed release.
export const PREPARATION_QUESTIONS_ENGLISH = Object.freeze({
  title: 'Questions about my preparation',
  intro: 'Select anything you would like to discuss with your hospital team.',
  select: 'Select this question',
  saveSelected: 'Save selected questions to My Care',
  printSelected: 'Print selected questions',
  saved: 'Already in My Care',
  savedConfirmation: 'Selected questions saved to My Care on this device.',
  noSelection: 'Select one or more questions to save or print.',
  selectedSummary: 'Questions I want to ask',
  summaryIntro: 'These are the preparation questions you selected. You can save them to My Care or print them for your appointment.',
  openMyCare: 'Open My Care',
  printNote: 'Printing does not send your questions to the hospital.',
  safety: 'These questions do not replace your hospital’s instructions. For medicines, fasting and discharge arrangements, follow the individual advice given by your hospital team.',
  questions: {
    fasting: 'When should I stop eating and drinking before my operation?',
    medicines: 'Which of my usual medicines should I take or change before my operation?',
    arrivalDay: 'Where do I need to go, and what time should I arrive?',
    arrivalInpatient: 'Where should I go and when should I arrive for my admission?',
    transport: 'Do I need to arrange transport to hospital, or ask whether I am eligible for patient transport?',
    homeSupport: 'Will I need someone to take me home or stay with me after surgery?',
    dischargeSupport: 'What help might I need when I leave hospital, and who should I discuss it with?',
    aftercareContact: 'Who should I contact if I have concerns after I return home?',
  },
});
